<template>
  <div
    class="row g-2 g-lg-2"
    :style="{
      'margin-bottom': ($route.name === 'trip-create-external' ? -50 : 0) + 'px'
    }"
  >
    <div class="col-xl-4 my-5">
      <div class="actions">
        <div class="row">
          <div class="col-md-6" style="text-align: center">
            <button type="button" class="btn shadow-none" @click="addPick">
              <i
                class="bi bi-plus-circle"
                style="color: #262c66; margin-right: 10px"
              ></i
              >Add Pickup
            </button>
          </div>
          <div class="col-md-6" style="text-align: center">
            <button type="button" class="btn shadow-none" @click="addDrop">
              <i
                class="bi bi-plus-circle"
                style="color: #262c66; margin-right: 10px"
              ></i
              >Add Dropoff
            </button>
          </div>
        </div>
        <div class="row my-5 main-input-div">
          <div class="col-md-12">
            <div class="pick">
              <div class="row m-0">
                <!-- <div class="col-sm-2">
                  <i class="bi bi-record-circle-fill"></i>
                </div> -->
                <div class="col-sm-12">
                  <i class="bi bi-record-circle-fill"></i>
                  <input
                    type="text"
                    name=""
                    class="pick-input origin"
                    placeholder="Pick"
                    data-location-name=""
                  />
                </div>
              </div>
              <AddPickup
                v-for="input in pickInputs"
                :key="input.key"
                :id="input.id"
                :kv="input.key"
                :autocomplete="autocomplete"
                :google="google"
                @pickup="setPickupPoint"
                @removepickup="deletePickupInput"
              />
            </div>
            <div class="main-dots">
              <div class="row" style="margin-top: -20px">
                <div class="col">
                  <div>&#xFE19;</div>
                </div>
              </div>
            </div>
            <div class="drop">
              <div class="row m-0">
                <!-- <div class="col-sm-2">
                  <i class="bi bi-geo-alt-fill"></i>
                </div> -->
                <div class="col-sm-12">
                  <i class="bi bi-geo-alt-fill"></i>
                  <input
                    type="text"
                    name=""
                    class="drop-input destination"
                    placeholder="Drop"
                    data-location-name=""
                  />
                </div>
              </div>
              <AddDropoff
                v-for="input in dropInputs"
                :key="input.key"
                :id="input.id"
                :kv="input.key"
                :autocomplete="autocomplete"
                :google="google"
                @dropoff="setDropoff"
                @removedropoff="deleteDropoff"
              />
            </div>
            <div class="next-button-holder">
              <button
                v-if="$route.name === 'trip-create'"
                type="button"
                class="btn btn-primary next-button shadow-none"
                :disabled="countPickAndDrop.length"
                @click="goToTripCreateRequest"
              >
                Next
              </button>
              <button
                v-if="$route.name === 'trip-create-external'"
                type="button"
                class="btn btn-primary next-button shadow-none"
                :disabled="countPickAndDrop.length"
                @click="mapSaveAPICall"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{
        'col-xl-8': true,
        'p-0': true,
        'vh-100': true,
        'mb-4': $route.name !== 'trip-create-external'
      }"
    >
      <div id="map"></div>
    </div>
  </div>
</template>

<script>
import { Loader } from 'google-maps';
import AddDropoff from '../components/trip-create/AddDropoff.vue';
import AddPickup from '../components/trip-create/AddPickup.vue';
import axios from 'axios';
import http from '../config/axios';
import credentials from '../config/credentials.js';
import { vehicleRequest } from '../store/vehicleRequest/vehicleRequest';

export default {
  name: 'TripCreateRequest',
  components: {
    AddPickup,
    AddDropoff
  },
  data() {
    return {
      pickInputs: [],
      dropInputs: [],
      coordinates: {
        lat: 23.810431079332343,
        lng: 90.41242187756868
      },
      zoom: 13,
      markers: [],
      selectedPlacesInfo: [],
      map: '',
      google: '',
      directionsService: '',
      directionsDisplay: '',
      pickData: [],
      dropData: [],
      waypts: [],
      autocomplete: '',
      distance: 0,
      duration: 0,
      infoWindow: null,
      pickMarker: null,
      dropMarker: null,
      wayPoints: [],
      pickWayPoints: [],
      dropWayPoints: [],
      loader: '',
      viaWaypoints: null,
      vehicleRequest
    };
  },
  beforeMount() {
    this.loader = new Loader(credentials.GOOGLE_MAP_API_KEY, {
      libraries: ['places']
    });
  },
  mounted() {
    // this.getUserWisePermissionList();
    if (this.$route.name !== 'trip-map-show') {
      localStorage.removeItem('waypoints');
      localStorage.removeItem('viaWaypoints');
      localStorage.removeItem('pickData');
      localStorage.removeItem('dropData');
    }
    if (this.$route.name === 'trip-create-external') {
      if (
        this.$route.params.route_id &&
        (this.$route.params.service_type === 'b2c' ||
          this.$route.params.service_type === 'B2C')
      ) {
        this.b2cMapLoad();
      } else if (
        this.$route.params.route_id &&
        (this.$route.params.service_type === 'b2b' ||
          this.$route.params.service_type === 'B2B')
      ) {
        this.b2bMapLoad();
      } else {
        this.initMap();
      }
    } else {
      this.initMap();
    }
  },
  updated() {
    let pickInputs = document.querySelectorAll('.pick-input');
    let dropInputs = document.querySelectorAll('.drop-input');

    let currentPickInputValues = [];
    let currentDropInputValues = [];

    pickInputs.forEach((input) => {
      if (input.dataset.locationName) {
        currentPickInputValues.push({
          location: input.dataset.locationName
        });
      }
    });

    dropInputs.forEach((input) => {
      if (input.dataset.locationName) {
        currentDropInputValues.push({
          location: input.dataset.locationName
        });
      }
    });

    this.pickWayPoints.length = 0;
    this.dropWayPoints.length = 0;

    this.waypts = this.waypts.filter(
      (item, index, self) =>
        index ===
        self.findIndex((t) => t.name === item.name && t.type === item.type)
    );

    // this.pickWayPoints = this.waypts.filter((waypoint) => {
    //   return currentPickInputValues.find((value) => {
    //     if (value.location === waypoint.name) {
    //       return waypoint;
    //     }
    //   });
    // });
    // this.dropWayPoints = this.waypts.filter((waypoint) => {
    //   return currentDropInputValues.find((value) => {
    //     if (value.location === waypoint.name) {
    //       return waypoint;
    //     }
    //   });
    // });

    this.pickWayPoints = this.waypts.filter((waypoint) => {
      return waypoint.type === 'pick';
    });
    this.dropWayPoints = this.waypts.filter((waypoint) => {
      return waypoint.type === 'drop';
    });

    // let currentPick = this.pickWayPoints.filter((waypoint) => {
    //   return waypoint.type === 'pick';
    // });
    // let currentDrop = this.dropWayPoints.filter((waypoint) => {
    //   return waypoint.type === 'drop';
    // });

    let currentPick = this.pickWayPoints.slice();
    let currentDrop = this.dropWayPoints.slice();

    localStorage.setItem('waypoints', JSON.stringify(this.waypts));
    // store latest pick point in local storage
    localStorage.setItem('pickData', JSON.stringify(currentPick));

    // store latest drop points in local storage
    window.localStorage.setItem('dropData', JSON.stringify(currentDrop));

    // google map route draw color and width option
    // let polylineOptionsActual = {
    //   strokeColor: '#2b72e4',
    //   strokeOpacity: 1.0,
    //   strokeWeight: 7,
    //   geodesic: true,
    //   fillColor: 'red',
    //   fillOpacity: 1.0
    // };
    // this.directionsDisplay.setOptions({
    //   polylineOptions: polylineOptionsActual
    // });

    if (this.pickWayPoints.length > 0 && this.dropWayPoints.length > 0) {
      let origin = currentPick.shift();
      let destination = currentDrop.pop();

      let allPoints = currentPick.concat(currentDrop);
      let waypoints = [];

      if (this.viaWaypoints) {
        waypoints = this.viaWaypoints;
      } else {
        allPoints.forEach((point) => {
          waypoints.push({
            location: point.location,
            stopover: false
          });
        });
      }

      this.directionsService
        .route({
          origin: origin.location,
          destination: destination.location,
          waypoints: waypoints,
          travelMode: this.google.maps.DirectionsTravelMode['DRIVING']
        })
        .then((result) => {
          this.directionsDisplay.setDirections(result);
          this.directionsDisplay.directions.routes[0].legs[0].via_waypoints =
            JSON.parse(window.localStorage.getItem('via_waypoint'));

          this.computeTotalDistance(result);
          let bounds = new this.google.maps.LatLngBounds();
          let route = result.routes[0];
          for (let i = 0; i < route.legs.length; i++) {
            bounds.extend(route.legs[i].start_location);
            bounds.extend(route.legs[i].end_location);
          }
        })
        .catch((e) => {
          alert('Could not display directions due to: ' + e);
        });
    }
  },

  methods: {
    b2cMapLoad() {
      axios
        .get(
          `${process.env.VUE_APP_b2c_SERVICE_URL}route/${this.$route.params.route_id}/map-points`,
          {
            headers: {
              'Content-type': 'application/json',
              Authorization: this.$route.params.token
            }
          }
        )
        .then((result) => {
          if (result.data?.map_attributes) {
            let mapData = vehicleRequest.decodeMapData(
              result.data.map_attributes
            );
            if (mapData) {
              localStorage.setItem(
                'waypoints',
                JSON.stringify(mapData.waypoints)
              );
              localStorage.setItem(
                'viaWaypoints',
                JSON.stringify(mapData.viaWaypoints)
              );
              localStorage.setItem(
                'pickData',
                JSON.stringify(mapData.pickData)
              );
              localStorage.setItem(
                'dropData',
                JSON.stringify(mapData.dropData)
              );
            }
          } else {
            // this.$swal('Error', 'Map attributes not found!', 'error');
          }
          this.initMap();
        })
        .catch((error) => {
          this.initMap();
          console.log(error.response?.data?.message);
        });
    },
    b2bMapLoad() {
      axios
        .get(
          `${process.env.VUE_APP_b2b_SERVICE_URL}api/paths/map-details/${this.$route.params.route_id}`,
          {
            headers: {
              'Content-type': 'application/json',
              token: this.$route.params.token
            }
          }
        )
        .then((result) => {
          if (result.data?.data) {
            let mapData = vehicleRequest.decodeMapData(result.data.data);
            if (mapData) {
              localStorage.setItem(
                'waypoints',
                JSON.stringify(mapData.waypoints)
              );
              localStorage.setItem(
                'viaWaypoints',
                JSON.stringify(mapData.viaWaypoints)
              );
              localStorage.setItem(
                'pickData',
                JSON.stringify(mapData.pickData)
              );
              localStorage.setItem(
                'dropData',
                JSON.stringify(mapData.dropData)
              );
            }
          } else {
            // this.$swal('Error', 'Map attributes not found!', 'error');
          }
          this.initMap();
        })
        .catch((error) => {
          this.initMap();
          console.log(error.response?.data?.message);
        });
    },
    initMap() {
      this.viaWaypoints = JSON.parse(localStorage.getItem('viaWaypoints'));
      setTimeout(() => {
        this.viaWaypoints = null;
      }, 2000);

      var pick = JSON.parse(localStorage.getItem('pickData'));
      var drop = JSON.parse(localStorage.getItem('dropData'));

      if (pick?.length && drop?.length) {
        this.loader.load().then((google) => {
          this.pickData.push(pick.length);
          this.dropData.push(drop.length);
          this.map = new google.maps.Map(document.getElementById('map'), {
            center: this.coordinates,
            zoom: this.zoom,
            mapTypeId: 'roadmap',
            gestureHandling: 'greedy'
          });
          this.google = google;

          this.directionsService = new google.maps.DirectionsService();
          this.directionsDisplay = new google.maps.DirectionsRenderer({
            map: this.map,
            draggable: true,
            suppressMarkers: true,
            polylineOptions: {
              strokeWeight: 4,
              strokeOpacity: 0.3
            },
            preserveViewport: true
          });
          this.infoWindow = new google.maps.InfoWindow({
            maxWidth: 200
          });

          this.directionsDisplay.setMap(this.map);
          // get via_waypoints from localStorage
          // let wayPoints = JSON.parse(localStorage.getItem('via_waypoint'));
          // set to directionsDisplay

          let polylineOptionsActual = {
            strokeColor: '#652f8f',
            strokeOpacity: 1.0,
            strokeWeight: 6,
            geodesic: true,
            fillColor: 'red',
            fillOpacity: 1.0
          };
          this.directionsDisplay.setOptions({
            polylineOptions: polylineOptionsActual
          });

          for (let i = 0; i < pick.length - 1; i++) {
            this.pickInputs.push({
              id: i + 1,
              key: (Math.random() + 1).toString(36).substring(7)
            });
          }
          for (let i = 0; i < drop.length - 1; i++) {
            this.dropInputs.push({
              id: i + 1,
              key: (Math.random() + 1).toString(36).substring(7)
            });
          }

          let or = pick[0];
          let de = drop[0];
          let pickInputEl = document.querySelector('.pick-input.origin');
          pickInputEl.value = or.name;
          pickInputEl.dataset.locationName = or.name;
          let dropInputEl = document.querySelector('.drop-input.destination');
          dropInputEl.value = de.name;
          dropInputEl.dataset.locationName = de.name;
          let pickPlace = new google.maps.places.Autocomplete(pickInputEl, {
            componentRestrictions: {
              country: 'BD'
            }
          });
          pickPlace.addListener('place_changed', () => {
            let pPlace = pickPlace.getPlace();
            this.pickData.push({
              position: pPlace.geometry.location
            });

            let wayPointValue = {
              type: 'pick',
              name: pPlace.name,
              placeId: pPlace.place_id,
              location: pPlace.geometry.location,
              lat: pPlace.geometry.location.lat(),
              lng: pPlace.geometry.location.lng()
            };

            let oldWayPointIndex = this.findWayPointIndexByName(
              pickInputEl.dataset.locationName
            );

            if (oldWayPointIndex || oldWayPointIndex === 0) {
              this.waypts[oldWayPointIndex] = wayPointValue;
            } else {
              this.waypts.push(wayPointValue);
            }

            pickInputEl.value = pPlace.name;
            pickInputEl.dataset.locationName = pPlace.name;

            this.$forceUpdate();
          });
          let dropPlace = new google.maps.places.Autocomplete(dropInputEl, {
            componentRestrictions: {
              country: 'BD'
            }
          });
          dropPlace.addListener('place_changed', () => {
            let dPlace = dropPlace.getPlace();
            this.dropData.push({
              position: dPlace.geometry.location
            });

            let wayPointValue = {
              type: 'drop',
              name: dPlace.name,
              placeId: dPlace.place_id,
              location: dPlace.geometry.location,
              lat: dPlace.geometry.location.lat(),
              lng: dPlace.geometry.location.lng()
            };

            let oldWayPointIndex = this.findWayPointIndexByName(
              dropInputEl.dataset.locationName
            );

            if (oldWayPointIndex || oldWayPointIndex === 0) {
              this.waypts[oldWayPointIndex] = wayPointValue;
            } else {
              this.waypts.push(wayPointValue);
            }

            dropInputEl.value = dPlace.name;
            dropInputEl.dataset.locationName = dPlace.name;

            this.$forceUpdate();
          });

          setTimeout(() => {
            const cusPick = document.querySelectorAll('.custom-pac-input');
            pick.shift();
            cusPick.forEach((p, ind) => {
              let pickPlace = new google.maps.places.Autocomplete(p, {
                componentRestrictions: {
                  country: 'BD'
                }
              });
              pickPlace.addListener('place_changed', () => {
                let dPlace = pickPlace.getPlace();
                this.dropData.push({
                  position: dPlace.geometry.location
                });

                let wayPointValue = {
                  type: 'pick',
                  name: dPlace.name,
                  placeId: dPlace.place_id,
                  location: dPlace.geometry.location,
                  lat: dPlace.geometry.location.lat(),
                  lng: dPlace.geometry.location.lng()
                };

                let oldWayPointIndex = this.findWayPointIndexByName(
                  p.dataset.locationName
                );

                if (oldWayPointIndex || oldWayPointIndex === 0) {
                  this.waypts[oldWayPointIndex] = wayPointValue;
                } else {
                  this.waypts.push(wayPointValue);
                }

                p.value = dPlace.name;
                p.dataset.locationName = dPlace.name;
                this.$forceUpdate();
              });
              p.value = pick[ind].name;
              p.dataset.locationName = pick[ind].name;
              this.pickData.push({
                position: p.position
              });
            });
            const cusDrop = document.querySelectorAll(
              '.custom-drop-pac-input.drop-input'
            );
            drop.shift();
            cusDrop.forEach((d, ind) => {
              let dropPlace = new google.maps.places.Autocomplete(d, {
                componentRestrictions: {
                  country: 'BD'
                }
              });
              dropPlace.addListener('place_changed', () => {
                let dPlace = dropPlace.getPlace();
                this.dropData.push({
                  position: dPlace.geometry.location
                });

                let wayPointValue = {
                  type: 'drop',
                  name: dPlace.name,
                  placeId: dPlace.place_id,
                  location: dPlace.geometry.location,
                  lat: dPlace.geometry.location.lat(),
                  lng: dPlace.geometry.location.lng()
                };

                let oldWayPointIndex = this.findWayPointIndexByName(
                  d.dataset.locationName
                );

                if (oldWayPointIndex || oldWayPointIndex === 0) {
                  this.waypts[oldWayPointIndex] = wayPointValue;
                } else {
                  this.waypts.push(wayPointValue);
                }

                d.value = dPlace.name;
                d.dataset.locationName = dPlace.name;
                this.$forceUpdate();
              });
              d.value = drop[ind].name;
              d.dataset.locationName = drop[ind].name;

              this.dropData.push({
                position: d.position
              });
            });
          }, 260);

          this.waypts = JSON.parse(localStorage.getItem('waypoints'));

          new google.maps.event.addListener(
            this.directionsDisplay,
            'directions_changed',
            () => {
              const directions = this.directionsDisplay.getDirections();

              if (directions) {
                this.computeTotalDistance(directions);
                this.saveViaWaypoints(directions);
                // this.directionsDisplay.directions.routes[0].legs[0].via_waypoint;
              }
              // this.$forceUpdate();
            }
          );

          this.$forceUpdate();
        });
      } else {
        this.loader.load().then((google) => {
          this.map = new google.maps.Map(document.getElementById('map'), {
            center: this.coordinates,
            zoom: this.zoom,
            mapTypeId: 'roadmap',
            gestureHandling: 'greedy'
          });
          this.google = google;

          this.directionsService = new google.maps.DirectionsService();
          this.directionsDisplay = new google.maps.DirectionsRenderer({
            map: this.map,
            draggable: true,
            suppressMarkers: true,
            polylineOptions: {
              strokeWeight: 4,
              strokeOpacity: 0.3
            },
            preserveViewport: true
          });
          this.infoWindow = new google.maps.InfoWindow({
            maxWidth: 200
          });

          this.directionsDisplay.setMap(this.map);

          let polylineOptionsActual = {
            strokeColor: '#652f8f',
            strokeOpacity: 1.0,
            strokeWeight: 6,
            geodesic: true,
            fillColor: 'red',
            fillOpacity: 1.0
          };
          this.directionsDisplay.setOptions({
            polylineOptions: polylineOptionsActual
          });

          let pickInputs = document.querySelector('.pick-input');
          pickInputs.value = '';
          pickInputs.dataset.locationName = '';

          let pickPlace = new google.maps.places.Autocomplete(pickInputs, {
            componentRestrictions: {
              country: 'BD'
            }
          });
          this.autocomplete = pickPlace;
          pickPlace.addListener('place_changed', () => {
            let pPlace = pickPlace.getPlace();
            this.pickData.push({
              position: pPlace.geometry.location
            });

            let wayPointValue = {
              type: 'pick',
              name: pPlace.name,
              placeId: pPlace.place_id,
              location: pPlace.geometry.location,
              lat: pPlace.geometry.location.lat(),
              lng: pPlace.geometry.location.lng()
            };

            let oldWayPointIndex = this.findWayPointIndexByName(
              pickInputs.dataset.locationName
            );

            if (oldWayPointIndex || oldWayPointIndex === 0) {
              this.waypts[oldWayPointIndex] = wayPointValue;
            } else {
              this.waypts.push(wayPointValue);
            }

            pickInputs.value = pPlace.name;
            pickInputs.dataset.locationName = pPlace.name;

            this.$forceUpdate();
          });

          let dropInputs = document.querySelector('.drop-input');
          dropInputs.value = '';
          dropInputs.dataset.locationName = '';

          let dropPlace = new google.maps.places.Autocomplete(dropInputs, {
            componentRestrictions: {
              country: 'BD'
            }
          });
          dropPlace.addListener('place_changed', () => {
            let dPlace = dropPlace.getPlace();
            this.dropData.push({
              position: dPlace.geometry.location
            });

            let wayPointValue = {
              type: 'drop',
              name: dPlace.name,
              placeId: dPlace.place_id,
              location: dPlace.geometry.location,
              lat: dPlace.geometry.location.lat(),
              lng: dPlace.geometry.location.lng()
            };

            let oldWayPointIndex = this.findWayPointIndexByName(
              dropInputs.dataset.locationName
            );

            if (oldWayPointIndex || oldWayPointIndex === 0) {
              this.waypts[oldWayPointIndex] = wayPointValue;
            } else {
              this.waypts.push(wayPointValue);
            }

            dropInputs.value = dPlace.name;
            dropInputs.dataset.locationName = dPlace.name;
            // this.routeDraw();

            this.$forceUpdate();
          });
          // fire event when user change drawing path
          this.directionsDisplay.addListener('directions_changed', () => {
            const directions = this.directionsDisplay.getDirections();

            if (directions) {
              this.computeTotalDistance(directions);
              this.saveViaWaypoints(directions);
            }
          });
        });
      }
    },
    addPick() {
      this.pickInputs.push({
        id: this.pickRowCount,
        key: (Math.random() + 1).toString(36).substring(7)
      });
    },
    addDrop() {
      this.dropInputs.push({
        id: this.dropRowCount,
        key: (Math.random() + 1).toString(36).substring(7)
      });
    },
    setPickupPoint(place, oldPlaceName) {
      this.pickData.push({
        position: place.geometry.location
      });

      let wayPointValue = {
        type: 'pick',
        name: place.name,
        placeId: place.place_id,
        location: place.geometry.location,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };

      let oldWayPointIndex = this.findWayPointIndexByName(oldPlaceName);

      if (oldWayPointIndex || oldWayPointIndex === 0) {
        this.waypts[oldWayPointIndex] = wayPointValue;
      } else {
        this.waypts.push(wayPointValue);
      }
      // this.routeDraw();

      this.$forceUpdate();
    },
    setDropoff(place, oldPlaceName) {
      this.dropData.push({
        position: place.geometry.location
      });

      let wayPointValue = {
        type: 'drop',
        name: place.name,
        placeId: place.place_id,
        location: place.geometry.location,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };

      let oldWayPointIndex = this.findWayPointIndexByName(oldPlaceName);

      if (oldWayPointIndex || oldWayPointIndex === 0) {
        this.waypts[oldWayPointIndex] = wayPointValue;
      } else {
        this.waypts.push(wayPointValue);
      }
      // this.routeDraw();

      this.$forceUpdate();
    },
    saveViaWaypoints(directions) {
      let viaWaypoints = directions.routes[0].legs[0].via_waypoint;
      let formattedViaWaypoints = [];

      viaWaypoints.forEach((point) => {
        formattedViaWaypoints.push({
          location: point.location,
          stopover: false
        });
      });

      window.localStorage.setItem(
        'viaWaypoints',
        JSON.stringify(formattedViaWaypoints)
      );
    },
    computeTotalDistance(response) {
      let distance = 0;
      let duration = 0;

      let route = response.routes[0];
      for (let i = 0; i < route.legs.length; i++) {
        distance += route.legs[i].distance.value;
        duration += route.legs[i].duration.value;
      }
      distance = (distance / 1000).toFixed(2);
      duration = (duration / 60).toFixed(2);

      this.distance = distance;
      this.duration = duration;
      // store distance in local storage
      window.localStorage.setItem('distance', this.distance);

      // remove markers
      this.markers.forEach((marker) => {
        marker.visible = false;
      });

      // add markers to pickWayPoints array
      var bounds = new this.google.maps.LatLngBounds();
      this.pickWayPoints.forEach((waypoint) => {
        let marker = new this.google.maps.Marker({
          position: waypoint.location,
          map: this.map,
          draggable: true
        });
        marker.id = this.markers.length;
        marker.name = waypoint.name;
        marker.type = waypoint.type;
        bounds.extend(marker.position);
        this.markers.push(marker);
      });

      // add markers to dropWayPoints array
      this.dropWayPoints.forEach((waypoint) => {
        let marker = new this.google.maps.Marker({
          position: waypoint.location,
          map: this.map,
          draggable: true
        });
        marker.id = this.markers.length;
        marker.name = waypoint.name;
        marker.type = waypoint.type;
        bounds.extend(marker.position);
        this.markers.push(marker);
      });

      this.map.fitBounds(bounds);
      // this.google.maps.event.trigger(this.map, 'resize');

      // add markers drag start event to markers array
      let startMarker = {};
      this.markers.forEach((marker) => {
        marker.addListener('drag', () => {
          startMarker = marker;
        });
      });

      // add markers drag event to markers array
      this.markers.forEach((marker) => {
        marker.addListener('dragend', (event) => {
          let { type } = this.waypts.find((waypoint) => {
            return waypoint.name == startMarker.name;
          });

          // this.waypts = this.waypts.filter((waypoint) => {
          //   return waypoint.name !== startMarker.name;
          // });

          let duplicateRemove = this.waypts.filter(
            (tag, index, array) =>
              array.findIndex(
                (t) => t.name == tag.name && t.type == tag.type
              ) == index
          );
          this.waypts.length = 0;
          this.waypts = [...duplicateRemove];

          let geoCoder = new this.google.maps.Geocoder();
          let waypoint = {};

          geoCoder.geocode({ location: event.latLng }, (results, status) => {
            if (status == this.google.maps.GeocoderStatus.OK) {
              // let lat = results[0].geometry.location.lat();
              // let lng = results[0].geometry.location.lng();
              // let location = results[0].geometry.location;
              let lat = event.latLng.lat();
              let lng = event.latLng.lng();
              let location = event.latLng;
              let placeId = results[0].place_id;

              waypoint = {
                location: location,
                placeId: placeId,
                lat: lat,
                lng: lng,
                name: results[0].formatted_address,
                type: type
              };

              let oldWayPointIndex = this.findWayPointIndexByName(marker.name);
              if (oldWayPointIndex || oldWayPointIndex === 0) {
                this.waypts[oldWayPointIndex] = waypoint;
              } else {
                this.waypts.push(waypoint);
              }

              marker.name = results[0].formatted_address;
              if (marker.type == 'pick') {
                this.pickData.push({
                  position: location
                });
                this.updateInputField();
              } else if (marker.type == 'drop') {
                this.dropData.push({
                  position: location
                });
                this.updateInputField();
              }

              this.$forceUpdate();
            }
          });
        });
      });

      this.infoWindow.close();

      let html = `<img class="img-fluid" src="https://icon-library.com/images/google-maps-car-icon/google-maps-car-icon-18.jpg" width="22" height="20" /> <span style="font-weight: 700">${duration} min</span>`;
      this.infoWindow.setContent(html + '<br>' + distance + ' km');
      this.infoWindow.setPosition(
        route.overview_path[Math.floor(route.overview_path.length / 2)]
      );
      this.infoWindow.open(this.map);

      let infoCloseBtn = document.querySelector('.gm-ui-hover-effect');
      if (infoCloseBtn) {
        infoCloseBtn.style.display = 'none';
      }
    },
    deletePickupInput(id, locationName) {
      this.pickInputs = this.pickInputs.filter((input) => {
        return input.key !== id;
      });
      this.waypts = this.waypts.filter((point) => {
        return !(point.type === 'pick' && point.name === locationName);
      });
    },
    deleteDropoff(id, locationName) {
      this.dropInputs = this.dropInputs.filter((input) => {
        return input.key !== id;
      });
      this.waypts = this.waypts.filter((point) => {
        return !(point.type === 'drop' && point.name === locationName);
      });
    },
    findWayPointIndexByName(name) {
      let waypointIndex = null;

      this.waypts.forEach((point, index) => {
        if (name === point.name) {
          waypointIndex = index;
        }
      });

      return waypointIndex;
    },
    updateInputField() {
      let mainPickInput = document.querySelector('.pick-input.origin');
      let mainDropInput = document.querySelector('.drop-input.destination');
      let cusPickInput = document.querySelectorAll('.custom-pac-input');
      let cusDropInput = document.querySelectorAll(
        '.custom-drop-pac-input.drop-input'
      );
      let p = 0;
      let d = 0;

      this.markers.forEach((marker) => {
        if (marker.visible) {
          if (marker.type === 'pick') {
            if (p === 0) {
              mainPickInput.value = marker.name;
              mainPickInput.dataset.locationName = marker.name;
            } else if (cusPickInput[p - 1]) {
              cusPickInput[p - 1].value = marker.name;
              cusPickInput[p - 1].dataset.locationName = marker.name;
            }
            p++;
          } else if (marker.type === 'drop') {
            if (d === 0) {
              mainDropInput.value = marker.name;
              mainDropInput.dataset.locationName = marker.name;
            } else if (cusDropInput[d - 1]) {
              cusDropInput[d - 1].value = marker.name;
              cusDropInput[d - 1].dataset.locationName = marker.name;
            }
            d++;
          }
        }
      });
    },
    allPointsSelected() {
      let numOfPoints = 2;
      let cusPickInput = document.querySelectorAll('.custom-pac-input');
      let cusDropInput = document.querySelectorAll(
        '.custom-drop-pac-input.drop-input'
      );
      numOfPoints += cusPickInput ? cusPickInput.length : 0;
      numOfPoints += cusDropInput ? cusDropInput.length : 0;

      let numOfMarkers = 0;
      this.markers.forEach((marker) => {
        if (marker.visible) {
          numOfMarkers++;
        }
      });

      return numOfPoints === numOfMarkers;
    },
    goToTripCreateRequest() {
      if (this.allPointsSelected()) {
        this.$router.push({
          name: 'trip-request-form'
        });
      } else {
        this.$swal(
          'Warning',
          'Select all the points before proceeding!',
          'warning'
        );
      }
    },
    mapSaveAPICall() {
      let pathDetails = {
        waypoints: JSON.parse(localStorage.getItem('waypoints')),
        viaWaypoints: JSON.parse(localStorage.getItem('viaWaypoints')),
        pickData: JSON.parse(localStorage.getItem('pickData')),
        dropData: JSON.parse(localStorage.getItem('dropData'))
      };
      let distance = this.distance;
      let routeParams = this.$route.params;

      if (routeParams.action === 'update') {
        if (routeParams.route_id) {
          if (
            routeParams.service_type === 'b2c' ||
            routeParams.service_type === 'B2C'
          ) {
            axios
              .post(
                `${process.env.VUE_APP_b2c_SERVICE_URL}route-map-points/store/${routeParams.route_id}`,
                {
                  route_id: routeParams.route_id,
                  points: [...pathDetails.pickData, ...pathDetails.dropData],
                  map_attributes: pathDetails,
                  total_distance: distance
                },
                {
                  headers: {
                    'Content-type': 'application/json',
                    Authorization: routeParams.token
                  }
                }
              )
              .then((response) => {
                this.$partnerSwal.quickSuccessAlert.fire({
                  title: 'Success',
                  text: response.data?.message
                });
              })
              .catch((error) => {
                this.$swal('Error!', error.response?.data?.message, 'error');
              });
          } else if (
            routeParams.service_type === 'b2b' ||
            routeParams.service_type === 'B2B'
          ) {
            axios
              .post(
                `${process.env.VUE_APP_b2b_SERVICE_URL}api/store-path-points/${routeParams.route_id}`,
                {
                  route_id: routeParams.route_id,
                  points: [...pathDetails.pickData, ...pathDetails.dropData],
                  map_attributes: pathDetails,
                  total_distance: distance
                },
                {
                  headers: {
                    'Content-type': 'application/json',
                    token: routeParams.token
                  }
                }
              )
              .then((response) => {
                this.$partnerSwal.quickSuccessAlert.fire({
                  title: 'Success',
                  text: response.data?.message
                });
              })
              .catch((error) => {
                this.$swal('Error!', error.response?.data?.message, 'error');
              });
          } else {
            this.$swal('Error!', 'Can not save map for your service!', 'error');
          }
        } else {
          this.$swal(
            'Error!',
            'Route ID is mandatory to save the map!',
            'error'
          );
        }
      } else {
        this.$swal(
          'Error!',
          'There is no effect for the action you defined!',
          'error'
        );
      }
    },

    getUserWisePermissionList() {
      var user_code = localStorage.getItem('userCode');
      http
        .get(
          `/v2/role-permission/role-and-user?role_name=Internal User&user_id=${user_code}`
        )
        .then((response) => {
          if (response.status === 200) {
            return localStorage.setItem(
              'userPermission',
              Object.values(response.data.data)
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  computed: {
    pickRowCount() {
      return this.pickInputs.length + 1;
    },
    dropRowCount() {
      return this.dropInputs.length + 1;
    },
    countPickAndDrop() {
      if (this.pickData.length >= 1 && this.dropData.length >= 1) {
        return '';
      } else {
        return 'disabled';
      }
    }
  },
  watch: {
    pickInputs: {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    },
    dropInputs: {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
:deep(input) {
  background: none;
}
@media (min-width: 961px) {
  #map {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
  }
}
@media (min-width: 1025px) {
  #map {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
  }
}
@media (min-width: 1281px) {
  #map {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
  }
}

.actions {
  display: block;
  margin-right: 10px;
}

input {
  border: 0;
  outline: 0;
  padding: -5px 5px;
  border-bottom: 2px solid #c4c4c4;
  font-size: 18px;
  width: 70%;
  color: #4f4949;
  margin-left: 15px;
  /* margin: -10px -40px; */
}

.main-dots {
  font-size: 40px;
  margin-bottom: -6px;
  /* margin-top: -10px; */
  /* padding-left: calc(var(--bs-gutter-x) * 0.9); */
}

.bi {
  color: #652f8f;
  cursor: pointer;
}

.list-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.arrow-up-down {
  cursor: pointer;
  margin-right: 60px;
}

.next-button-holder {
  text-align: center;
  width: 100%;
  margin: 4rem 0;
}
.next-button {
  text-align: center;
  width: 80%;
  padding: 5px;
  border-radius: 4px;
  cursor: pointer;
}

.bi-record-circle-fill::before {
  content: '\f517';
  margin-top: 1px;
  margin-bottom: 20px;
}
</style>
